import { TechnologyCardWrapper } from "../../styles/StyledComponents/ExpertiseToTransformWrapper";
import { ITechnologyCardprops } from "../../ui/interface";

const TechnologyCard = ({
  dataNo,
  description,
  title,
}: ITechnologyCardprops) => {
  return (
    <TechnologyCardWrapper>
      <p className="dataNo">{dataNo}</p>
      <div className="detailsWrap">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </TechnologyCardWrapper>
  );
};

export default TechnologyCard;


